var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5 flex-grow-1 flex-shrink-0 position-relative"},[_c('div',{staticClass:"banner-main no-navigation h-100",style:('background-image: url(' + _vm.translatedConfig('bannerUrl') + ')')}),_c('MachineSearchComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }